import ThemeProvider from "../context/themeContext";
import React from "react";
import { ThemeSwitcher } from "../component/themeSwitch";
import "../index.css";

export default function AuthLayout({ children }: React.PropsWithChildren) {
  return (
    <>
      <div className="absolute top-0 right-0 z-50">
        <ThemeSwitcher />
      </div>
      {children}
    </>
  );
}
